import { useRbacConfig } from '@/shared/features/rbac/context/rbac-config-context';
import { TRbacApi } from '@/shared/features/rbac/context/rbac-config-context.types';

// Single entry point for the ident API. The RBAC user/role hooks below are
// config-backed (app-injected); the rest is re-exported from enhanced-ident-api.
export {
  identApi,
  useReadTenantQuery,
  useReadTenantsForUserQuery,
  useSelectTenantMutation,
  useUpdateTenantMutation,
  useReadPoliciesForOwnUserQuery,
  useReadUsersCountQuery,
  useReadGroupedIdentitiesCountQuery,
  useReadUngroupedIdentitiesCountQuery,
  useGenerateTwoFactorAuthTokenMutation,
  useAuthenticateTwoFactorAuthTokenMutation,
  useVerifyTotpTwoFactorAuthMutation,
  useReadTermsAndConditionsAcceptanceQuery,
  useAcceptTermsAndConditionsMutation,
} from '@/shared/redux/api/ident/enhanced-ident-api';

export const useReadAllRolesQuery: TRbacApi['useReadAllRolesQuery'] = (
  ...args
) => useRbacConfig().api.useReadAllRolesQuery(...args);

export const useReadRoleQuery: TRbacApi['useReadRoleQuery'] = (...args) =>
  useRbacConfig().api.useReadRoleQuery(...args);

export const useReadAllUsersQuery: TRbacApi['useReadAllUsersQuery'] = (
  ...args
) => useRbacConfig().api.useReadAllUsersQuery(...args);

export const useReadUserQuery: TRbacApi['useReadUserQuery'] = (...args) =>
  useRbacConfig().api.useReadUserQuery(...args);

export const useReadUsersForRoleQuery: TRbacApi['useReadUsersForRoleQuery'] = (
  ...args
) => useRbacConfig().api.useReadUsersForRoleQuery(...args);

export const useReadUserRoleLinksForUserQuery: TRbacApi['useReadUserRoleLinksForUserQuery'] =
  (...args) => useRbacConfig().api.useReadUserRoleLinksForUserQuery(...args);

export const useReadUserRoleLinksForRoleQuery: TRbacApi['useReadUserRoleLinksForRoleQuery'] =
  (...args) => useRbacConfig().api.useReadUserRoleLinksForRoleQuery(...args);

export const useReadPoliciesForUserQuery: TRbacApi['useReadPoliciesForUserQuery'] =
  (...args) => useRbacConfig().api.useReadPoliciesForUserQuery(...args);

export const useReadOwnUserRolesQuery: TRbacApi['useReadOwnUserRolesQuery'] = (
  ...args
) => useRbacConfig().api.useReadOwnUserRolesQuery(...args);

export const useCreateUserMutation: TRbacApi['useCreateUserMutation'] = (
  ...args
) => useRbacConfig().api.useCreateUserMutation(...args);

export const useUpdateUserMutation: TRbacApi['useUpdateUserMutation'] = (
  ...args
) => useRbacConfig().api.useUpdateUserMutation(...args);

export const useDeleteUserMutation: TRbacApi['useDeleteUserMutation'] = (
  ...args
) => useRbacConfig().api.useDeleteUserMutation(...args);

export const useCreateUserRoleMutation: TRbacApi['useCreateUserRoleMutation'] =
  (...args) => useRbacConfig().api.useCreateUserRoleMutation(...args);

export const useUpdateUserRoleMutation: TRbacApi['useUpdateUserRoleMutation'] =
  (...args) => useRbacConfig().api.useUpdateUserRoleMutation(...args);

export const useDeleteRoleMutation: TRbacApi['useDeleteRoleMutation'] = (
  ...args
) => useRbacConfig().api.useDeleteRoleMutation(...args);

export const useLinkRoleToUserMutation: TRbacApi['useLinkRoleToUserMutation'] =
  (...args) => useRbacConfig().api.useLinkRoleToUserMutation(...args);

export const useRemoveRoleFromUserMutation: TRbacApi['useRemoveRoleFromUserMutation'] =
  (...args) => useRbacConfig().api.useRemoveRoleFromUserMutation(...args);

export const useUpdateUserRoleLinkMutation: TRbacApi['useUpdateUserRoleLinkMutation'] =
  (...args) => useRbacConfig().api.useUpdateUserRoleLinkMutation(...args);

export const useReadUserUiPreferencesQuery: TRbacApi['useReadUserUiPreferencesQuery'] =
  (...args) => useRbacConfig().api.useReadUserUiPreferencesQuery(...args);

export const useUpdateUserUiPreferencesMutation: TRbacApi['useUpdateUserUiPreferencesMutation'] =
  (...args) => useRbacConfig().api.useUpdateUserUiPreferencesMutation(...args);
